
import request from '@/utils/request'


// 查询菜单列表
export function listMenu(para) {
  return request({
    url: '/system/menu/list',
    method: 'post',
    data: para
  })
}

/***
 * get请求类型，
 * 通过menuId 获取菜单的详情
 * 用途：菜单编辑用
 */
// 查询菜单详细
export function getMenu(menuId) {
  return request({
    url: '/system/menu/detail/' + menuId,
    method: 'get'
  })
}

/**
 * 增加菜单
 */
export function addMenu(para){
  return request({
    url: '/system/menu/add',
    method: 'post',
    data: para
  })
}
/**
 * 更新菜单
 */
export function updateMenu(para){
  return request({
    url: '/system/menu/edit',
    method: 'post',
    data: para
  })
}
/**
 * 更新菜单
 */
export function delMenu(para){
  return request({
    url: '/system/menu/del',
    method: 'post',
    data: para
  })
}


/**
 * 全部的菜单列表 ，和list 一样，使用list接口即可
 */
export function treeselect(){
  return request({
    url: '/system/menu/list',
    method: 'get'
  })
}

export function roleMenuTreeselect(roleId){
  return request({
    url: '/system/menu/roleMenuTreeselect/'+roleId,
    method: 'get'
  })
}